import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

export interface DeployKnowledgeBaseRequest {
  name: string;
  split_method: string;
  delfos_server_config_id?: string;
  container_name?: string;
}

export interface KnowledgeBaseHistoryEntry {
  id: string;
  archive_id: string;
  name: string;
  split_method: string;
  is_active: boolean;
  delfos_server_config_id?: string | null;
  container_name?: string | null;
  user: string;
  created_at: string;
}

export interface KnowledgeBaseOption {
  id: string;
  name: string;
  container_name?: string | null;
}

export const DEFAULT_CONTAINER_NAME = 'delfos-cache';

export const DECISION_TREE_SPLIT_METHOD = 'decision_tree';

export const SPLIT_METHODS: { excel: string[]; pdf: string[]; decisionTree: string[] } = {
  excel: ['lines'],
  pdf: ['pages', 'tables', 'summary_based', 'regex'],
  decisionTree: [DECISION_TREE_SPLIT_METHOD],
};

export function splitMethodsForFile(fileName: string): string[] {
  const lower = (fileName || '').toLowerCase();
  if (lower.endsWith('.xls') || lower.endsWith('.xlsx')) {
    return SPLIT_METHODS.excel;
  }
  if (lower.endsWith('.pdf')) {
    return SPLIT_METHODS.pdf;
  }
  if (lower.endsWith('.json')) {
    return SPLIT_METHODS.decisionTree;
  }
  return [...SPLIT_METHODS.excel, ...SPLIT_METHODS.pdf];
}

export function isDeployableFile(fileName: string): boolean {
  const lower = (fileName || '').toLowerCase();
  return lower.endsWith('.pdf') || lower.endsWith('.xls') || lower.endsWith('.xlsx') || lower.endsWith('.json');
}

@Injectable({ providedIn: 'root' })
export class KnowledgeBaseService {
  private baseUrl = '/api/knowledge-bases/';

  constructor(private http: HttpClient) {}

  deploy(archiveId: string, data: DeployKnowledgeBaseRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}${archiveId}/deploy`, data);
  }

  getHistory(archiveId: string): Observable<KnowledgeBaseHistoryEntry[]> {
    return this.http
      .get<{ message: string; knowledge_bases: KnowledgeBaseHistoryEntry[] }>(`${this.baseUrl}${archiveId}/history`)
      .pipe(map(res => res.knowledge_bases));
  }

  list(): Observable<KnowledgeBaseOption[]> {
    return this.http
      .get<{ message: string; knowledge_bases: KnowledgeBaseOption[] }>(this.baseUrl)
      .pipe(map(res => res.knowledge_bases));
  }
}
